// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module--buttonContainer--439fd";
export var content = "styles-module--content--be068";
export var contentContainer = "styles-module--contentContainer--aba76";
export var image = "styles-module--image--6b384";
export var imageContainer = "styles-module--imageContainer--fbe44";
export var leftImage = "styles-module--leftImage--015a5";
export var lightMode = "styles-module--lightMode--3d738";
export var rightImage = "styles-module--rightImage--8e134";
export var section = "styles-module--section--9c56a";
export var wideImage = "styles-module--wideImage--97066";